import Swiper from 'swiper';
import { Navigation, Controller, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/controller';
import 'swiper/css/effect-fade';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const urlParams = new URLSearchParams(window.location.search);
const level = urlParams.get('niveau');

let infos_slider = new Swiper('.plan-slider__infos-slider', {
  modules: [EffectFade],
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  allowTouchMove: false
})

let images_slider = new Swiper('.plan-slider__images', {
  modules: [Navigation, Controller],
  autoHeight: true,
  //direction: "vertical",
  //slidesPerView: "auto",
  navigation: {
    prevEl: '.plan-slider__prev',
    nextEl: '.plan-slider__next',
  },
  simulateTouch: false,
  controller: {
    control: infos_slider
  }
})

if(level){
  let level_slide = document.querySelector(`.plan-slider__images .swiper-slide[data-level="${level}"]`)
  if(level_slide){
    images_slider.slideTo(level_slide.dataset.index)
  }
}

Fancybox.bind("[data-fancybox]", {
  // Your custom options
});

